<template>
  <div class="content_pwd">
    <div class="pwd_text" v-if="hideTips">
      您的密码强度太弱，请先修改密码再登录！
    </div>
    <div class="pwd_row" style="margin-bottom: 60px;">
      <label class="label_text">原密码</label>
      <div class="input_content">
        <el-input
          type="password"
          class="pwd_before"
          v-model="beforePwd"
          placeholder="输入原密码"
          auto-complete="off"
          @input="check_input()"
        ></el-input>
      </div>
    </div>
    <div class="pwd_row">
      <label class="label_text">新密码</label>
      <div class="input_content">
        <el-input
          type="password"
          class="pwd_value"
          v-model="newPwd"
          placeholder="输入新密码"
          auto-complete="off"
          maxlength="16"
          @input="pwd_input_change()"
        ></el-input>
      </div>
    </div>
    <div class="pwd_row">
      <label class="label_text">验 证</label>
      <div class="input_content">
        <el-input
          type="password"
          class="pwd_value"
          v-model="confirmPwd"
          placeholder="再次输入新密码"
          auto-complete="off"
          maxlength="16"
          @input="pwd_input_check()"
        ></el-input>
      </div>
    </div>
    <div class="pwd_strength" v-show="valueLevel != ''">
      <div class="strength_value" :class="valueLevel"></div>
    </div>
    <div class="check_tips" v-show="tipsContent != ''">
      {{ tipsContent }}
    </div>
    <div class="bottom" @click="submit()" v-show="hideshow">
      <span class="sure_btn">确定</span>
    </div>
  </div>
</template>
<script>
import { parseUrlParam, getPwdScore } from "@/utils/common";
export default {
  name: "changepwd",
  data() {
    return {
      userName: "",
      appId: "",
      beforePwd: "",
      newPwd: "",
      confirmPwd: "",
      tipsContent: "",
      valueLevel: "",
      hideTips: false,
      submitOnOff: false,
      docmHeight: document.documentElement.clientHeight, //默认屏幕高度
      showHeight: document.documentElement.clientHeight, //实时屏幕高度
      hideshow: true
    };
  },
  mounted() {
    window.onresize = () => {
      return (() => {
        this.showHeight = document.body.clientHeight;
      })();
    };
    this.init();
  },
  watch: {
    showHeight: function() {
      if (this.docmHeight > this.showHeight) {
        this.hideshow = false;
      } else {
        this.hideshow = true;
      }
    }
  },
  methods: {
    init() {
      let paramsObj = parseUrlParam();
      this.userName = decodeURIComponent(paramsObj.userName);
      this.appId = paramsObj.appId;
      if (Number(paramsObj.tips) === 0) {
        this.hideTips = true;
      } else {
        this.hideTips = false;
      }
    },
    check_input() {
      let ascllVal = this.beforePwd.charCodeAt(this.beforePwd.length - 1);
      if (ascllVal == 32) {
        this.beforePwd = this.beforePwd.substring(0, this.beforePwd.length - 1);
      }
    },
    pwd_input_check() {
      this.confirmPwd = this.checkCodeChar(this.confirmPwd);
    },
    pwd_input_change() {
      this.newPwd = this.checkCodeChar(this.newPwd);
      let pwd_score = getPwdScore(this.newPwd);
      if (pwd_score > 45 && pwd_score <= 60) {
        this.tipsContent = "";
        this.valueLevel = "value_level2";
      } else if (pwd_score > 60) {
        this.tipsContent = "";
        this.valueLevel = "value_level3";
      } else {
        this.tipsContent = "密码强度太弱，建议使用大小写字母/数字/下划线";
        this.valueLevel = "value_level1";
      }
    },
    checkCodeChar(code) {
      let codeArr = code.split("");
      let ascllVal = null;
      let newCode = [];
      for (let i = 0; i < codeArr.length; i++) {
        ascllVal = code.charCodeAt(i);
        if (ascllVal >= 48 && ascllVal <= 57) {
          newCode.push(codeArr[i]);
        } else if (ascllVal >= 65 && ascllVal <= 90) {
          newCode.push(codeArr[i]);
        } else if (ascllVal >= 97 && ascllVal <= 122) {
          newCode.push(codeArr[i]);
        } else if (ascllVal == 95) {
          newCode.push(codeArr[i]);
        }
      }
      return newCode.join("");
    },
    submit() {
      let that = this;
      if (this.beforePwd === "") {
        this.tipsContent = "请输入原密码";
        return;
      }
      if (this.newPwd === "" || this.confirmPwd === "") {
        this.tipsContent = "请输入密码";
        return;
      }
      let pwd_score = getPwdScore(this.newPwd);
      if (pwd_score <= 45) {
        this.tipsContent = "密码强度太弱，建议使用大小写字母/数字/下划线";
        this.valueLevel = "value_level1";
        return;
      }
      if (this.newPwd.length < 6 || this.newPwd.length > 16) {
        this.tipsContent = "密码必须6-16位";
        return;
      }
      if (
        !new RegExp("[a-zA-Z]").test(this.newPwd) ||
        !new RegExp("[0-9]").test(this.newPwd)
      ) {
        this.tipsContent = "密码必须包括字母数字";
        return;
      }
      if (this.newPwd !== this.confirmPwd) {
        this.tipsContent = "两次输入的密码不一致";
        return;
      }
      let timestamp = new Date().getTime();
      let dealBeforePwd = androidProxy.encryption(this.beforePwd);
      let newPwd = androidProxy.encryption(this.newPwd);
      let clientId = 5;
      let paramKey = [
        "appId",
        "userName",
        "newPassword",
        "originalPassword",
        "time",
        "clientId"
      ];
      let paramVal = [
        this.appId.toString(),
        this.userName,
        newPwd,
        dealBeforePwd,
        timestamp.toString(),
        clientId.toString()
      ];
      let sign = androidProxy.getSN(
        "updatePasswordByOriginalPassword.do",
        paramKey,
        paramVal
      );
      let formData = new FormData();
      formData.append("userName", this.userName);
      formData.append("appId", this.appId);
      formData.append("originalPassword", dealBeforePwd);
      formData.append("newPassword", newPwd);
      formData.append("sign", sign);
      formData.append("time", timestamp);
      formData.append("clientId", clientId);
      if (this.submitOnOff) {
        return;
      }
      this.submitOnOff = true;
      this.tipsContent = "";
      that.$ajax
        .post(`${that.$apihost}/updatePasswordByOriginalPassword.do`, formData)
        .then(res => {
          that.submitOnOff = false;
          if (res.result == 1) {
            let obj = {
              result: 1,
              msg: "密码已修改，请重新登陆",
              data: { newPwd }
            };
            alert(JSON.stringify(obj));
          } else {
            alert(JSON.stringify(res));
          }
        })
        .catch(() => {
          that.submitOnOff = false;
        });
    },
    getParams(str) {
      let urlParam = {};
      let params = str.split("&");
      for (let i = 0; i < params.length; i++) {
        let k = params[i].substring(0, params[i].indexOf("="));
        let v = params[i].substring(params[i].indexOf("=") + 1);
        if (v.indexOf("#") > 0) {
          v = v.substring(0, v.indexOf("#"));
        }
        urlParam[k] = v;
      }
      return urlParam;
    }
  }
};
</script>
<style>
#app {
  background: transparent;
}
</style>
<style lang="scss" scoped>
.content_pwd {
  position: relative;
  padding: 32px 24px;
  width: 100%;
  height: 100%;
  background: #f9f8ff;
}
.pwd_text {
  padding: 0 8px;
  line-height: 54px;
  color: #4a4a4a;
  font-size: 18px;
  background: #fff3d2;
  border: 1px solid #ffe18d;
  border-radius: 1px;
  -webkit-border-radius: 1px;
  -moz-border-radius: 1px;
  -ms-border-radius: 1px;
  -o-border-radius: 1px;
}
.pwd_row {
  position: relative;
  padding-left: 120px;
  line-height: 54px;
  margin-top: 16px;
  font-size: 16px;
  background: #ffffff;
  border-radius: 5px;
  -webkit-border-radius: 5px;
  -moz-border-radius: 5px;
  -ms-border-radius: 5px;
  -o-border-radius: 5px;
}
.pwd_row .label_text {
  position: absolute;
  left: 16px;
  color: #333333;
}
.pwd_row .input_content input {
  height: 54px;
  line-height: 54px;
  border: none;
  font-size: 16px;
  width: 400px;
  outline: none;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
}
.pwd_strength {
  height: 10px;
  background: #ecebeb;
  margin-top: 16px;
  border-radius: 5px;
  -webkit-border-radius: 5px;
  -moz-border-radius: 5px;
  -ms-border-radius: 5px;
  -o-border-radius: 5px;
  margin-left: 120px;
}
.pwd_strength .strength_value {
  height: 10px;
  border-radius: 5px;
  -webkit-border-radius: 5px;
  -moz-border-radius: 5px;
  -ms-border-radius: 5px;
  -o-border-radius: 5px;
}
.strength_value.value_level1 {
  width: 30%;
  background: #e46b6b;
}
.strength_value.value_level2 {
  width: 60%;
  background: #f3cf6d;
}
.strength_value.value_level3 {
  width: 100%;
  background: #7fd6b0;
}
.check_tips {
  padding: 4px 0px;
  color: #e46b6b;
  font-size: 14px;
  line-height: 14px;
  margin-left: 120px;
}
.bottom {
  height: 54px;
  width: 38%;
  line-height: 54px;
  font-size: 16px;
  color: #ffffff;
  background: #6592ff;
  text-align: center;
  border-radius: 27px;
  -webkit-border-radius: 27px;
  -moz-border-radius: 27px;
  -ms-border-radius: 27px;
  -o-border-radius: 27px;
  position: absolute;
  bottom: 32px;
  left: 50%;
  transform: translate(-50%, 0);
}
</style>
